<template>
  <OpenSeadragon
    id="imageViewer"
    :key="'penseadragon'"
    ref="openseadragon"
    class="has-background-dark"
    :options="options"
    style="width: 100%; height: 100%"
    @open="onOpen"
  />
</template>

<script>
// const svgOverlay = require("svg-overlay");

import { mapState } from "vuex";

import imageMixin from "../../mixins/image.js";

import OpenSeadragon from "../vue-openseadragon.vue";

import { svgOverlay } from "../../utils/openseadragon-svg-overlay.js";

export default {
  components: {
    OpenSeadragon,
  },
  mixins: [imageMixin],
  props: {
    // source: {
    //   type: String,
    //   required: true,
    // },
    width: {
      type: Number,
      required: true,
      default: 100,
    },
    height: {
      type: Number,
      required: true,
    },
    xmlJson: {
      type: Object,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    overlays: null,
    selectedOverlayIndex: null,
    layoutElements: {},
    // width: 0,
    // height: 0,
    selectedLayoutElement: null,
    highlightedLayoutElement: null,
    selectedOverlayIndex: null,
  }),
  watch: {
    /*
     ** FIXME: use reactive style everywhere, i.e. change variable in methods,
     **        then watch this variable, perform action when it has changed
     */
    data: {
      handler: function (newValue, oldValue) {
        // if (newValue) this.layoutElements = this.renderLayout(newValue);
      },
      deep: true,
    },
    selected: {
      handler: function (newValue, oldValue) {
        if (newValue !== null && newValue.origin !== "image") {
          this.selectLayoutElement(newValue.target);
          // this.fitBounds(newValue.target, true);
          // this.panTo(newValue.target)
        }
      },
      deep: true,
    },
    centerLineID: {
      handler: function(newValue, oldValue) {
        if (newValue !== null && newValue.origin !== 'image') {
          this.selectLayoutElement(newValue.target)
          this.fitBounds(newValue.target, true)
          this.panTo(newValue.target)
        }
      },
      deep: true,
    },
    highlighted: {
      handler: function (newValue, oldValue) {
        if (newValue !== null && newValue.origin !== "image")
          this.highlightLayoutElement(newValue.target);
      },
      deep: true,
    },
    // iiifUrl: {
    //   handler: async function (newValue, oldValue) {
    //   console.log('image changed fit width and height')
    //   const response = await fetch(newValue);
    //   const data = await response.json();
    //   console.log('imageInfo ', data)
    //   this.height = data.height
    //   this.width = data.width
    //   this.onOpen()
      
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapState("content", ["data", "selected", "highlighted", "iiifUrl","centerLineID"]),
    options() {
      const baseUrl =
        "https://cdnjs.cloudflare.com/ajax/libs/openseadragon/2.4.0";
      return {
        tileSources: this.iiifUrl,
        zoomPerClick: 1.2,
        prefixUrl: `${baseUrl}/images/`,
        maxZoomLevel: 5,
        showZoomControl: false,
        showHomeControl: false,
        showFullPageControl: false,
        visibilityRatio: 0.2,
      };
    },
  },
  destroyed() {
    // clear svg node's content
    if (this.$refs.openseadragon) {
      const viewer = this.$refs.openseadragon.viewer;
      const overlay = viewer.svgOverlay();
      const svgNode = overlay.node();

      if (svgNode) svgNode.innerHTML = "";
    }
  },
  methods: {
    onOpen() {
      this.fitToWidth();

      if (this.xmlJson) this.layoutElements = this.renderLayout(this.xmlJson);

      if (this.overlays === null)
        this.overlays = Object.freeze(this.createOverlays());

      // const index = this.parseNumber(this.$route.query.result);
      // if (index !== null && this.results.length > 0)
      //   this.selectedOverlayIndex = index;

      if (this.selectedOverlayIndex !== null)
        this.selectWithPan(this.selectedOverlayIndex, false);
    },
    fitToWidth() {
      /*
       ** as seen on https://github.com/openseadragon/openseadragon/issues/839#issuecomment-181968800
       */
      const viewer = this.$refs.openseadragon.viewer;
      const viewportBounds = viewer.viewport.getBounds();
      const viewportAspect = viewportBounds.height / viewportBounds.width;
      const newBounds = viewer.world.getHomeBounds();
      newBounds.height = newBounds.width * viewportAspect;
      viewer.viewport.fitBounds(newBounds, false);
    },
    setHome() {
      if (!this.$refs.openseadragon) return;
      const viewer = this.$refs.openseadragon.viewer;
      // disables zoom on click
      viewer.gestureSettingsMouse.clickToZoom = false;

      /*
       ** as seen on https://github.com/openseadragon/openseadragon/issues/839#issuecomment-181968800
       */
      const viewportBounds = viewer.viewport.getBounds();
      const viewportAspect = viewportBounds.height / viewportBounds.width;
      const newBounds = viewer.world.getHomeBounds();
      newBounds.height = newBounds.width * viewportAspect;
      viewer.viewport.fitBounds(newBounds, true);
    },
    panTo(index, isAnimated = false) {
      if (this.results.length > 0) {
        const { rect } = this.results[index];
        const point = {
          x: (rect.x + rect.width ) ,
          y: (rect.y + rect.height ),
        };
        this.$refs.openseadragon.panTo(point, !isAnimated);
      }
    },
    zoom(delta) {
      if (!this.$refs.openseadragon) return;

      const viewer = this.$refs.openseadragon.viewer;

      if (delta > 0) {
        viewer.viewport.zoomBy(1.5);
      } else {
        viewer.viewport.zoomBy(1 / 1.5);
      }
      viewer.viewport.applyConstraints();
    },
    async fitBounds(id, isAnimated = false) {
      const data = await this.$store.dispatch("content/findElementById", id);
      if (data === null) return;

      const toRect = (points) => {
        const x = Math.min.apply(
          null,
          data.geometry.coords.map((p) => p.x)
        );
        const y = Math.min.apply(
          null,
          data.geometry.coords.map((p) => p.y)
        );
        const width =
          Math.max.apply(
            null,
            data.geometry.coords.map((p) => p.x)
          ) - x;
        const height =
          Math.max.apply(
            null,
            data.geometry.coords.map((p) => p.y)
          ) - y;
        return { x, y, width, height };
      };

      const rect = this.getScaledRect(
        this.getPaddedRect(toRect(data.geometry.coords), 75)
      );

      const point = {
        x: rect.x + rect.width ,
        y: rect.y + rect.height ,
      };

      this.$refs.openseadragon.panTo(point, true);
    
    },
    select(index, isAnimated) {
      if (this.overlays.length === 0) return;
      if (!(index < this.overlays.length)) return;

      const activeNode =
        this.selectedOverlayIndex === null
          ? null
          : this.overlays[this.selectedOverlayIndex].element;

      const node = this.overlays[index].element;

      if (activeNode && node !== activeNode)
        activeNode.classList.remove("is-selected");

      node.classList.add("is-selected");

      this.selectedOverlayIndex = index;
    },
    selectWithPan(index) {
      this.select(index, false);
      this.panTo(index, false);
    },
    renderLayout(data) {
      if (!this.$refs.openseadragon) return [];
      //  FIXME openseadragon viewer and editor use same refernece -> collision
      const viewer = this.$refs.openseadragon.viewer;
      // const svgOverlay = require("svg-overlay");

      const d3 = require("d3");
      const overlay = viewer.svgOverlay();
      const svg = d3.select(overlay.node());
      svg.attr("class", "layout");

      const contentGroup = svg.append("g");
      return data.elements.reduce((m, element) => {
        if (!element.geometry) return [];
        const pointsTemp = element.geometry.coords;
        if (pointsTemp)
          this.renderPolygon({
            parent: contentGroup,
            points: pointsTemp,
            className: "content",
          });

        const vm = this;

        const elementGroup = contentGroup.append("g");

        return element.elements.reduce((m, element) => {
          var points = element.geometry.coords;
          var id = element.attributes.id;

          if (element.type == "TableCell") {
            return element.elements.reduce((m, element) => {
              var points = element.geometry.coords;
              var id = element.attributes.id;

              const polygon = this.renderPolygon({
                parent: elementGroup,
                points: this.getScaledPoints(points, this.width),
                className: "element",
              })
                .on("click", () => {
                  this.selectLayoutElement(id);
                  this.$store.dispatch("content/select", {
                    target: id,
                    origin: "image",
                  });
                })
                .on("mouseover", () => this.highlightLayoutElement(id), true)
                .on("mouseout", () => this.highlightLayoutElement(id), true)
                .node();
              return Object.assign(m, { [id]: polygon });
            }, m);
          }
          const polygon = this.renderPolygon({
            parent: elementGroup,
            points: this.getScaledPoints(points, this.width),
            className: "element",
          })
            .on("click", () => {
              this.selectLayoutElement(id);
              this.$store.dispatch("content/select", {
                target: id,
                origin: "image",
              });
            })
            .on("mouseover", () => this.highlightLayoutElement(id), true)
            .on("mouseout", () => this.highlightLayoutElement(id), true)
            .node();
          return Object.assign(m, { [id]: polygon });
        }, m);
      }, {});
    },
    async selectLayoutElement(id) {
      const element = this.layoutElements[id];
      if (!element) return;

      if (
        this.selectedLayoutElement !== null &&
        element !== this.selectedLayoutElement &&
        this.selectedLayoutElement.classList.contains("is-selected")
      )
        this.selectedLayoutElement.classList.remove("is-selected");

      if (!element.classList.contains("is-selected")) {
        element.classList.add("is-selected");
      }

      if (element !== this.selectedLayoutElement)
        this.selectedLayoutElement = element;
    },
    highlightLayoutElement(id) {
      const element = this.layoutElements[id];
      if (!element) return;
      if (this.highlightedLayoutElement === element) {
        if (element.classList.contains("is-highlighted"))
          element.classList.remove("is-highlighted");
      } else {
        this.highlightedLayoutElement = element;

        if (!element.classList.contains("is-highlighted"))
          element.classList.add("is-highlighted");
      }

      this.$store.dispatch("content/highlight", {
        target: id,
        origin: "image",
      });
    },
    renderPolygon({ parent, points, className }) {
      return parent
        .append("polygon")
        .attr(
          "points",
          points.map(({ x, y }) => {
            return `${x},${y}`;
          })
        )
        .attr("class", className)
        .attr("tabindex", 0);
    },
    createOverlays() {
      if (!this.$refs.openseadragon) return [];

      const viewer = this.$refs.openseadragon.viewer;
      // const svgOverlay = require("svg-overlay");

      const d3 = require("d3");

      const overlay = viewer.svgOverlay();

      const svg = d3.select(overlay.node());

      return this.results.map(({ score, label, ...result }, index) => {
        const rect = this.getScaledRect(
          this.getPaddedRect(result.rect, this.height / 100)
        );

        const d3Rect = svg
          .append("rect")
          .attr("x", rect.x)
          .attr("y", rect.y)
          .attr("width", rect.width)
          .attr("height", rect.height)
          .attr("title", `${label} (${this.sanitizeScore(score)})`)
          .attr("class", "highlight is-primary")
          .on("click", () => {
            this.select(index, true);
          });

        return {
          d3: d3Rect,
          element: d3Rect.node(),
        };
      });
    },
    clear() {
      if (this.overlays.length === 0) return;
      const index = this.selectedOverlayIndex;

      if (!(this.index < this.overlays.length)) return;

      const node = this.overlays[index].element;
      if (node) node.classList.remove("is-selected");
      this.selectedOverlayIndex = null;
      this.setHome();
    },
    sanitizeScore(score) {
      return score === 1 || score === 0
        ? score + ".0"
        : Math.round(score * 100) / 100;
    },
  },
};
</script>
